import { LegendColor  } from "./legendcolor";

export class Legend{
   /**Nom affiché en titre de la légende */
    Name:string;
    Class:Array<LegendColor>;

    /**
     *
     */
    constructor() {
      this.Class = [];

    }

    /**
     * Initialise depuis une legend(permet cloner)
     * @param _iLegend legende
     */
    public Init(_iLegend:Legend){
      this.Name = _iLegend.Name;
      this.Class = [];
      if(_iLegend.Class && _iLegend.Class.length){
        _iLegend.Class.forEach((fCls:LegendColor)=>{
          let nwRang = new LegendColor();
          nwRang.Init(fCls)
          this.Class.push(nwRang);
        });

      }
    }
}